import { Flame, Activity, MapPin, Gauge, Clock, Target, Award, Trophy, Waves } from 'lucide-react';

// Maps template/badge icon strings (from the backend) to lucide components.
export const ICONS = {
  flame: Flame,
  activity: Activity,
  'map-pin': MapPin,
  gauge: Gauge,
  clock: Clock,
  target: Target,
  award: Award,
  trophy: Trophy,
  waves: Waves,
};

// Icon used to represent a metric type.
export const metricIcon = (m) => ({
  sessions: Waves,
  analyses: Activity,
  time_on_water: Clock,
  distance: Gauge,
  spots: MapPin,
  streak: Flame,
}[m] || Target);

// Canonical unit key for a metric (matches gamify.units.* i18n keys).
export const unitForMetric = (m) => ({
  sessions: 'sessions',
  analyses: 'analyses',
  time_on_water: 'minutes',
  distance: 'km',
  spots: 'spots',
  streak: 'weeks',
}[m] || 'sessions');

// Pretty-print a numeric value (drop trailing .0).
export const fmtNum = (n) => {
  const x = Number(n) || 0;
  return Number.isInteger(x) ? String(x) : x.toFixed(1);
};

export const ACCENT_FALLBACK = '#00B4D8';
